// The institute paid its plan online; licences stay locked until sales approves.
export const PLAN_AWAITING_APPROVAL = 'awaiting_approval';
export const awaitsPaymentApproval = (planPaymentStatus) => planPaymentStatus === PLAN_AWAITING_APPROVAL;

// What the Desk Ops institutions list shows in a row's status cell. The sales
// `stage` (and the licence) stay "active" when a school is suspended, so the
// school's own status (`tenant_status` from GET /ops/institutions) wins.
export function institutionRowStatus(row) {
  if (row.tenant_missing) return { kind: 'deleted', label: 'School deleted', title: "This institution's school was deleted" };
  if (row.tenant_status === 'suspended') {
    const title = row.suspension_reason ? `Suspended — ${row.suspension_reason}` : 'Suspended';
    return { kind: 'suspended', label: 'Suspended', title };
  }
  return { kind: 'stage' };
}
